import { SLACK_ENDPOINT } from "../config/constants"


export const postNotificationToSlackAPICall = async ({ payload }) => {
    try {

      const config = {
        method: 'POST',
        body: JSON.stringify(payload)
      }
      const slackResponse = await window.fetch(SLACK_ENDPOINT+'a', config)
      const responseOkBySlack = await slackResponse.ok

      return responseOkBySlack
    } catch (e) {
      console.error('ERROR: ', e)
      return e
    }
  }